$(document).ready(function() {
  var $window = $(window);
  var $document = $(document);
  var $body = $('body');
  var $masthead = $('#masthead');
  
  megaNavigation();
  adjustSiteHeaderColor();

  function megaNavigation() {
    var $siteNavItemLink = $masthead.find('.has-mega-nav');

    $siteNavItemLink
      .on('mouseenter', function(event) {
        var $activeMenu = $(event.target).closest('li');
        var $activeMegaMenu = $activeMenu.find('.mega-nav-container');
        $activeMegaMenu.addClass('show transition-in').removeClass('transition-out');
        event.stopPropagation();
      })
      .on('mouseleave', function() {
        $('.mega-nav-container').removeClass('show transition-in').addClass('transition-out');
      });
  }

  function adjustSiteHeaderColor() {
    var $header = $('.site-header');
    var $sections = $('.content-section');
    var sectionThemes = [];
    var scrollTimer;
    
    function updateSectionThemes() {
      sectionThemes = [];
      $sections.each(function() {
        var $section = $(this);
        var themeMode = $section.data('theme-mode');
        if (themeMode) {
          sectionThemes.push({
            top: $section.offset().top,
            bottom: $section.offset().top + $section.outerHeight(),
            theme: themeMode
          });
        }
      });
      
      handleScrollActions();
    }

    function handleScrollActions() {
      var scrollPosition = $document.scrollTop();
      var headerHeight = $header.outerHeight();
      var checkPosition = scrollPosition + headerHeight;
      var themeApplied = false;

      if ($('.announcement-bar').length > 0) {        
        $body.addClass('show-announcement-bar');
                
        const isScrolled = scrollPosition > 0;
        $body.toggleClass('scrolled', isScrolled);
      }

      $masthead.removeClass('color-inverse theme-light');

      for (var i = 0; i < sectionThemes.length; i++) {
        if (checkPosition >= sectionThemes[i].top && checkPosition <= sectionThemes[i].bottom) {
          $masthead.addClass(sectionThemes[i].theme);
          themeApplied = true;
          break;
        }
      }

      if (!themeApplied) {
        $masthead.addClass('theme-light');
      }
    }

    updateSectionThemes();
    $window.on('resize', updateSectionThemes);
    
    $window.on('scroll', function() {      
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(handleScrollActions, 10);
    });
  }
});